import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const userListAdmin = async () =>
  promiseHandler(baseAxios().get("admin/api/v1.0/user/list"));

export const userDetailsAdmin = async id =>
  promiseHandler(baseAxios().get(`admin/api/v1.0/user/details/${id}`));

export const userEditAdmin = async data =>
  promiseHandler(baseAxios().put("/admin/api/v1.0/User/update", data));
